<template>
  <va-modal
    :value="showModal"
    :noOutsideDismiss="false"
    ref="rolesByEntityModal"
    :cancelText="'agenda.cancel' | translate"
    cancelClass="btn-cancelar btn btn-primary btn-micro"
    :okClass="'none'"
    @cancel="closeDeleteModal">
    <div slot="title">
      <span>{{user.name}} - {{entity.name}}</span>
    </div>
    <div>
      <b>{{$t('users.roles.roles')}}:</b>
      <ul class="row">
        <li class="col-6" v-for="(role, index) in roles" :key="index">
          {{$t(`roles.${role.id}`, role.name)}}
        </li>
      </ul>
    </div>
  </va-modal>
</template>
<script>
export default {
  props: {
    roles: {
      type: Array,
      required: false,
      default: () => []
    },
    entity: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    closeDeleteModal: function () {
      setTimeout(() => {
        this.$emit('rolesByEntityModalClosed')
      }, 500)
    }
  }
}
</script>
